module.exports = __webpack_public_path__ + "static/img/Daniel-Annable.b0c63f1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Daniel-Annable.jpg
// module id = R4fj
// module chunks = 0